import { ExpandAltOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import type React from 'react';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type IWidgetParsedProps } from '../../../../inputs/common/util/getWidgetProps.ts';
import { type ISubsectionWidget } from '../../ISubsectionWidget.ts';
import { SubsectionDrawer } from './SubsectionDrawer.tsx';

export interface ISubsectionDrawerComponentProps {
  widget: ISubsectionWidget;
  options: IWidgetParsedProps;
  children?: React.ReactNode;
}

export function SubsectionDrawerComponent(
  props: ISubsectionDrawerComponentProps,
) {
  const { widget, options } = props;
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = useCallback(() => {
    setIsOpen(true);
  }, []);

  return (
    <>
      <Button
        size="large"
        block
        icon={
          <ExpandAltOutlined
            aria-label={t(
              'widgets.subsection-drawer-component.expand-aria',
              'Espandi',
            )}
          />
        }
        onClick={handleClick}
      >
        {widget.placeholder ??
          t('widgets.subsection-drawer-component.open', 'Apri')}
      </Button>

      <SubsectionDrawer widget={widget} isOpen={isOpen} setIsOpen={setIsOpen}>
        {props.children}
      </SubsectionDrawer>
    </>
  );
}
